import { useEffect, useMemo } from "react";
import { Table } from "../../components/Table";
import { Link } from "react-router-dom";
import { Button } from "../../components/Button";
import { FaPlus } from "react-icons/fa6";
import { Loader } from "../../components/Loader";
import Swal from "sweetalert2";
import axios from "axios";
import { FaTrashAlt } from "react-icons/fa";
import { useQuery } from "react-query";

const RestaurantsAdmins = () => {
  const { data, isLoading, refetch } = useQuery(
    "GetRestaurantsAdmins",
    async () => {
      const response = await axios.get("/restaurant-admin");
      return response.data.admins.map((el: any, index: number) => ({
        id: index + 1,
        name: el.name,
        email: el.email,
        restaurantName: el?.restaurant?.name,
        branchName: el?.restaurant?.Branchs[0]?.name,
        createdAt: new Date(el.createdAt).toLocaleDateString(),
        actions: (
          <Button lightRed onClick={() => handleDelete(el.id)}>
            <FaTrashAlt />
          </Button>
        ),
      }));
    }
  );

  const columns = useMemo(
    () => [
      {
        Header: "#",
        accessor: "id",
      },
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Restaurant",
        accessor: "restaurantName",
      },
      {
        Header: "Branch",
        accessor: "branchName",
      },
      {
        Header: "Created At",
        accessor: "createdAt",
      },
      {
        Header: "",
        accessor: "actions",
      },
    ],
    []
  );

  const handleDelete = async (id: string) => {
    Swal.fire({
      title: "? Are you sure",
      text: "! You can't reverse this deletion",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "! Yes, delete",
      cancelButtonText: "Cancel",
    }).then(async (result: any) => {
      if (result.isConfirmed) {
        await axios.delete(`/restaurant-admin/${id}`);
        refetch();
        Swal.fire({
          title: "Deleted",
          text: "The Admin has been removed",
          icon: "success",
          confirmButtonText: "Ok",
        });
      }
    });
  };

  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading)
    return (
      <div className="flex justify-center items-center pt-32">
        <Loader />
      </div>
    );

  return (
    <div>
      <header className="my-3 flex justify-between items-center">
        <h3 className="text-2xl font-medium">All Restaurants Admins</h3>
        <Link to="add">
          <Button className="!bg-primary flex items-center gap-2">
            <FaPlus />
            Add New
          </Button>
        </Link>
      </header>
      {!data && !isLoading && <div>No Restaurant Admins exists</div>}
      {data && <Table columns={columns} data={data} filter={true} />}
    </div>
  );
};

export default RestaurantsAdmins;
